import http from './http';

const httpPatch = async (url, data = undefined, config = undefined) => {
  const response = await http.patch(url, data, config);
  return response.data;
};

export default httpPatch;
